import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Circle } from "react-leaflet";

// Approximate area only: the circle is offset from the home and never shows the exact spot.
export function ApproxMap({ point, address }) {
  if (!point) return null;
  return (
    <section className="space-y-2" data-testid="listing-approx-map">
      <h2 className="text-lg font-semibold">Where you'll be</h2>
      <div className="h-64 overflow-hidden rounded-2xl border sm:h-80">
        <MapContainer center={[point.lat, point.lng]} zoom={14} scrollWheelZoom={false} className="h-full w-full">
          <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Circle center={[point.lat, point.lng]} radius={point.radius_m} pathOptions={{ color: "#0f766e", fillOpacity: 0.15 }} />
        </MapContainer>
      </div>
      <p className="text-sm text-stone-600" data-testid="listing-address-note">{address || "Approximate area. The exact address is shared once your stay is paid."}</p>
    </section>
  );
}
